import { useRef, useEffect } from 'react';

function useOnScrollLoad(
onScrolledCallback)
{
  var myRef = useRef(null);

  function handleScroll() {
    if (myRef && myRef.current) {
      if (
      myRef.current.scrollHeight <=
      // Ceils scrollTop as it often contains decimal values.
      // +1 is added because for some weird reason in some occasions clientHeight is one pixel smaller than it should be.
      Math.ceil(myRef.current.scrollTop + 1) + myRef.current.clientHeight)
      {
        onScrolledCallback(myRef.current.scrollTop);
      }
    }
  }

  useEffect(function () {var _myRef$current;
    myRef === null || myRef === void 0 ? void 0 : (_myRef$current = myRef.current) === null || _myRef$current === void 0 ? void 0 : _myRef$current.addEventListener('scroll', function () {return handleScroll();});
    return function () {var _myRef$current2;
      myRef === null || myRef === void 0 ? void 0 : (_myRef$current2 = myRef.current) === null || _myRef$current2 === void 0 ? void 0 : _myRef$current2.removeEventListener('scroll', function () {return handleScroll();});
    };
  }, []);

  return myRef;
}

export { useOnScrollLoad };
//# sourceMappingURL=useOnScrollLoad.js.map